export interface ApplicantAssessmentStatusCounterResponse {
    totalOpen: number;
    totalHired: number;
    totalRejected: number;
}

export const DefaultApplicantAssessmentStatusCounterResponse: ApplicantAssessmentStatusCounterResponse = {
    totalOpen: 0,
    totalHired: 0,
    totalRejected: 0,
};
